import React from 'react';
import { ButtonV2, Text, VerticalSpace } from '@arc-ui/components';
import { LoadingSpinner } from '../../atoms';
import SearchResultItem from '../SearchResultItem/SearchResultItem';
import { ResultsListProps } from '../../../types/results';

export const ResultsList: React.FC<ResultsListProps> = ({
  items,
  nbHits,
  isLastPage,
  isLoadingNextPage,
  query,
  onShowMore,
  sendEvent,
}) => (
  <div>
    <VerticalSpace size="24" />
    {items.map((hit, index) => (
      <React.Fragment key={hit.objectID}>
        <VerticalSpace size="32" />
        <SearchResultItem
          hit={{
            ...hit,
            query,
            __position: index + 1,
          }}
          sendEvent={sendEvent} // pass sendEvent down here
        />
      </React.Fragment>
    ))}
    {isLoadingNextPage && <LoadingSpinner size="small" />}

    <VerticalSpace size="24" />
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <Text elementType="p" size="m" aria-live="polite">
        Showing <strong>{items.length}</strong> of <strong>{nbHits}</strong>{' '}
        results
      </Text>
    </div>
    {!isLastPage && (
      <>
        <VerticalSpace size="12" />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <ButtonV2
            label="Load more results"
            onClick={() => {
              onShowMore();
            }}
            isLoading={isLoadingNextPage}
          />
        </div>
      </>
    )}
  </div>
);
